import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
// import useSortedColumns from "../../../../utils/useSortedColumns";
// import AdvanceSearch from "../../../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../../../ErrorBoundry";
import visileColumns from "./visibleColumns";
// import { Radio } from "@mui/material";
// import EligibilityTable from "../Eligibility/EligibilityTable";
import CustomizerContext from "../../../../_helper/Customizer";
import StatusCell from "../../../CertificateTracking/Components/JobAnnouncement/StatusCell";

function JobAnnouncementTable({setCurrentStep, GA=false}) {
    const { setEligibilityTableShow, EligibilityTableShow } = useContext(CustomizerContext);
    const ANNOUNCEMENT_ID_Value = useMemo(()=>{
        // const {ANNOUNCEMENT_ID} = EligibilityTableShow
        if(EligibilityTableShow?.ANNOUNCEMENT_ID) return EligibilityTableShow.ANNOUNCEMENT_ID.trim()
        return ""
    },[EligibilityTableShow])
    const dispatch = useDispatch();
    const history = useNavigate();
    const id = "ANNOUNCEMENTS-CL";
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
          results: searchResult.results,
          rowCount: searchResult.rowCount,
        };
      }, [searchResultsV2, id]);
    console.log(results,rowCount,'jobData1221')
    const { userData } = useAuth();
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([
        { field: "ANNOUNCEMENT_ID", dir: "desc" },
    ]);
    const [searchParams, setSearchParams] = useState([]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
    const [deleteData, setDeleteData] = useState(null);
    const [gg1ExportParams, setGG1ExportParams] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);

    const { postingResult, loading } = useSelector(
        (state) => state.JobAnnouncementReducer
    );


    const actions = useMemo(() => {
        return [
            {
                title: "Select",
                icon: { iconName: "k-icon k-i-radiobutton" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    console.log("added to table", props.dataItem);
                    // setApplicantTableShow(false)
                    setEligibilityTableShow(props.dataItem);
                    setCurrentStep(1)
                },
                isVisible: (dataProps) => {
                    return (
                        dataProps?.ANNOUNCEMENT_ID?.trim() != ANNOUNCEMENT_ID_Value
                    );
                  },
            },
            {
                title: "Select",
                icon: { iconName: "k-icon k-i-radiobutton-checked" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    // setEligibilityTableShow(props.dataItem);
                },
                isVisible: (dataProps) => {
                    console.log("dataProps1221", dataProps?.ANNOUNCEMENT_ID?.trim(),ANNOUNCEMENT_ID_Value);
                    return (
                        dataProps?.ANNOUNCEMENT_ID?.trim() == ANNOUNCEMENT_ID_Value
                    );
                  },
            }
        ];
    }, [ANNOUNCEMENT_ID_Value]);


    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    const columnWithStatus = useMemo(() => {
            return visileColumns.map((item) => {
                if (item.field === 'status') {
                    return {
                        ...item,
                        headerClassName: 'text-center',
                        className: 'd-flex align-items-center justify-content-center',
                        cell: (props) => (
                            <StatusCell dataItem={props.dataItem} GA={GA} />
                        )
                    };
                }
                return item;
            });
        }, [GA]);

    const [sortedColumns, setSortedColumns] = useState(columnWithStatus);

    // const [sortedColumns, setSortedColumns] = useSortedColumns(
    //     id,
    //     ColumnsSorted,
    //     [],
    //     visileColumns,
    //     userData
    // );

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    return (
        <ErrorBoundary>
            <Fragment>
                <Container fluid={true}>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card>
                                <CardHeader>
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <h5 className="m-0">Job Announcements List</h5>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div>
                                        <TelerikDataTable
                                            id={id}
                                            pageNumber={page}
                                            pageSize={pageSize}
                                            totalCount={rowCount}
                                            skip={(page - 1) * pageSize}
                                            take={pageSize}
                                            data={results || []}
                                            sortData={sortData}
                                            tableName={"announcement"}
                                            searchParams={searchParams}
                                            additionalWhere={additionalWhere}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                            onPageChange={handlePageChange}
                                            onPageSizeChange={handlePageSizeChange}
                                            selectedColumns={sortedColumns}
                                            setSortedColumns={setSortedColumns}
                                            loading={loadingSearch}
                                            enableFooterCell={false}
                                            dataLocation="pmis-global"
                                            actions={actions}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        </ErrorBoundary>
    );
}

export default JobAnnouncementTable;
